import { FC, useRef } from 'react';
import classNames from 'classnames/bind';
import InputDates from 'src/common/components/Search/Inputs/InputDates';
import PopoverDates from 'src/common/components/Search/Popover/PopoverDates';
import type { SearchRefs } from 'src/common/components/Search/SearchInputProvider';
import type { SearchHeroVariant } from 'src/common/components/Search/types';
import { useSearchHeroModalContext } from 'src/common/components/Search/SearchHero/SearchHeroModalProvider';
import styles from '../PopoverInputs.module.scss';

const cx = classNames.bind(styles);

type PopoverDatesInputProps = {
  refs: SearchRefs;
  variant?: SearchHeroVariant;
  className?: string;
};

const PopoverDatesInput: FC<PopoverDatesInputProps> = ({ refs, variant, className }) => {
  const modal = useSearchHeroModalContext();
  const ref = useRef<HTMLDivElement>(null);
  return (
    <div ref={ref} className={className}>
      <InputDates refs={refs} variant={variant} />
      <div className={cx(styles.popovers, `${variant}Variant`, { active: modal.active === 'dates' })}>
        <div className={styles.dates}>
          <PopoverDates refs={refs} />
        </div>
      </div>
    </div>
  );
};

export default PopoverDatesInput;
